import { useJobContext } from 'pages/Job/context';
import { useMemo } from 'react';
import { getJobDepositPayment } from 'utils/Job-functions';

export type JobFinanceOptionsDisplayType = 'all' | 'selected';

export interface JobFinanceDepositChosenHook {
  setDeposit: number;
  chosenDeposit: number;
  difference: number;
  higher: boolean;
  isNonCashDeposit: boolean;
}

export default function useJobFinanceDepositChosen(): JobFinanceDepositChosenHook {
  const { job } = useJobContext();

  const setDeposit = useMemo(() => job?.deposit_value?.amount || 0, [job]);

  const depositPayment = useMemo(() => getJobDepositPayment(job), [job]);

  const isNonCashDeposit = useMemo(
    () =>
      depositPayment?.payment_option.payment_method === 'bank' ||
      depositPayment?.payment_option.payment_method === 'card',
    [depositPayment],
  );

  const chosenDeposit = useMemo(
    () => job?.customer_options?.deposit_value?.amount || 0,
    [job],
  );

  const difference = useMemo(
    () => chosenDeposit - setDeposit,
    [chosenDeposit, setDeposit],
  );

  const higher = useMemo(() => difference > 0, [difference]);

  return {
    setDeposit,
    chosenDeposit,
    difference,
    higher,
    isNonCashDeposit,
  };
}
